import baseInfo from './base_info';
import dimension from './dimension';
import impressionClickCost from './impression_click_cost';
import goodEffect from './good_effect';
import agentAdv from './agent_adv';
import newAccount from './new_account';
import plansAndIdeas from './plans_and_ideas';
import { defaultDisplayColumnsConfig } from './default';

const allFieldsList = [
  ...baseInfo,
  ...dimension,
  ...impressionClickCost,
  ...goodEffect,
  ...agentAdv,
  ...newAccount,
  ...plansAndIdeas
];

// 维度字段
export const dimensionFieldsList = allFieldsList.filter(field => field.type === 'dimension');

// 指标字段
export const targetFieldsList = allFieldsList.filter(field => field.type === 'target');

// 默认展示字段
export const defaultFieldsList = allFieldsList.filter(field => defaultDisplayColumnsConfig.includes(field.key));

// 获取所有分支字段
export const branchFieldsList = (function() {
  const list = baseInfo.concat(dimension);
  return list.filter(field => field.branches).map(field => field.branches);
})();

// 获取趋势分析指标列表
export function getTrendAnalysisTargetsList() {
  return impressionClickCost
    .filter(field => field.chartTrend)
    .map(field => ({
      value: field.key,
      label: field.name
    }));
}

// 获取占比分析维度列表
export function getProportionAnalysisDimensionsList() {
  const _dimension = dimension
    .filter(field => field.chartProportion)
    .map(field => ({
      value: field.key,
      label: field.name
    }));
  const _baseInfo = baseInfo
    .filter(field => field.chartProportion)
    .map(field => ({
      value: field.key,
      label: field.name
    }));
  return _dimension.concat(_baseInfo);
}

// 获取占比分析指标列表
export function getProportionAnalysisTargetsList() {
  return impressionClickCost
    .filter(field => field.chartProportion)
    .map(field => ({
      value: field.key,
      label: field.name
    }));
}

export const isOCPCMapping = {
  0: '否',
  1: '是'
};

export const accountTypeMapping = {
  0: 'SMB',
  1: '创业',
  2: 'KA'
};

export default allFieldsList;
